export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      type: '',
      isExternal: false,
      points: []
    }
  }
}